// extracted by mini-css-extract-plugin
module.exports = {"list":"List-module--list--2pUMi"};